export default __webpack_public_path__ + "assets/icons/signature.92262695a36174426e82284b3fc5ca67.svg";